import React from 'react';
import { useParams } from 'react-router-dom';
// Update import to use the default export
 

 

const CategoryPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  
  return (
    <div className="category-page">
      <h1 className="text-2xl font-bold">Category: {slug}</h1>
      {/* Add category-specific content here */}
    </div>
  );
};

export default CategoryPage;
